import React, {Suspense, lazy, useState, useEffect} from "react";
import {
  HashRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";
import FirstScreenOptimizer from "./components/FirstScreenOptimizer";
import Loading from "./components/Loading";
import Home from "./pages/Home";
import SmartTravel from './pages/smart-travel'
import Enterprise from "./pages/enterprise";
import About from "./pages/about";
import Contact from "./pages/contact";

// 懒加载页面组件
// const Home = lazy(() => import("./pages/Home"));
// const SmartTravel = lazy(() => import("./pages/smart-travel"));
// const Enterprise = lazy(() => import("./pages/enterprise"));
// const About = lazy(() => import("./pages/about"));
// const Contact = lazy(() => import("./pages/contact"));

// 首屏关键资源定义 - 移除CSS资源，因为已经直接导入
const criticalResources: Array<{
  id: string;
  type: "image" | "script" | "style" | "component";
  url?: string;
  importFunc?: () => Promise<any>;
}> = [];

// 高优先级资源定义 - 移除CSS资源，因为已经直接导入
const highPriorityResources: Array<{
  id: string;
  type: "image" | "script" | "style" | "component";
  url?: string;
  importFunc?: () => Promise<any>;
}> = [];

// 自定义Suspense包装器，用于精确控制loading状态
const LoadingSuspense: React.FC<{ children: React.ReactNode }> = ({
                                                                    children,
                                                                  }) => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // 路由变化时立即隐藏Navbar
    setIsLoading(true);

    // 使用更短的延迟，确保页面加载完成后才显示Navbar
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 200);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      <div className={isLoading ? "navbar-hidden" : ""}>
        <Navbar/>
      </div>
      <Suspense
        fallback={
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              backgroundColor: "white",
              zIndex: 9999,
            }}
          >
            <Loading size={45}/>
          </div>
        }
      >
        {children}
      </Suspense>
    </>
  );
};

// 路由内容组件
const RouteContent: React.FC = () => {
  return (
    <LoadingSuspense>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/smart-travel" element={<SmartTravel/>}/>
        <Route path="/enterprise" element={<Enterprise/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/contact" element={<Contact/>}/>
      </Routes>
    </LoadingSuspense>
  );
};

const App: React.FC = () => {
  const [showFooter, setShowFooter] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowFooter(true), 1500); // 延迟 1.5s 加载 Footer
    return () => clearTimeout(timer);
  }, []);

  return (
    <FirstScreenOptimizer
      criticalResources={criticalResources}
      highPriorityResources={highPriorityResources}
    >
      <Router>
        <RouteContent/>
        {
          showFooter && <Footer/>
        }
        <FloatingButtons/>
      </Router>
    </FirstScreenOptimizer>
  );
};

export default App;
